import { getConfig } from '@superbet-group/web.lib.config';
import {
    createRestClient,
    RestClient,
} from '@superbet-group/web.lib.rest';
import { get as _get } from 'lodash';

import { defaultHttpTimeoutMs } from '@core/constants';
import { ArticleDto } from '@core/mappers/news/dtos/ArticleDto';

import {
    ApiArticles,
    ArticleQueryParams,
} from './Types';
import { SiteLanguageConfig } from '@modules/app/siteLanguage/siteLanguageConfig';

export default class RestService {
    private readonly restClient: RestClient;

    constructor() {
        const config = getConfig();
        const {
            host,
            project,
        } = config.newsHost as any; // todo will change with new config
        this.restClient = createRestClient(
            host,
            defaultHttpTimeoutMs,
            false,
            {
                headers: {
                    project,
                },
            },
        );
    }

    public async getAllArticles(currentPage = 0): Promise<ApiArticles> {
        const config = getConfig();
        /*
            Sportal CMS does not support multi-language for anything but Napoleon.
            This means leaving the language query for other countries will result in empty or fewer articles
        */
        const params: ArticleQueryParams = {
            status: 'active',
            published_at: 'active',
            query: '*',
            sort_by: 'published_at',
            sort_direction: 'desc',
            limit: _get(config, 'countrySpecific.services.news.pageSize', 20),
            page: currentPage,
        };

        if (SiteLanguageConfig.isMultiLingualSite) {
            params.language = config.appLocale.languageCode;
        }

        const response: ApiArticles = await this.restClient.get(
            '/articles/search',
            {
                params,
            });
        return response;
    }

    public getArticlesByMatchId(id: number): Promise<{ data: ArticleDto[] }> {
        return this.restClient.get(
            '/articles/search',
            {
                params: {
                    query: `generic.superbetMatchId=${id}`,
                },
            },
        );
    }

    public getArticleBySlug(slug: string): Promise<{ data: ArticleDto[] }> {
        return this.restClient.get(
            '/articles/search',
            {
                params: {
                    query: `seo.slug=${slug}`,
                },
            },
        );
    }
}
